/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Extracted_Text_Empty_TitleInputs */



/**
* | output |
* | --- |
* | "No extracted text yet" |
*
* @param {Spaces_Extracted_Text_Empty_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_extracted_text_empty_title = /** @type {((inputs?: Spaces_Extracted_Text_Empty_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Extracted_Text_Empty_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch kein extrahierter Text")
	return /** @type {LocalizedString} */ ("No extracted text yet")
});